// extracted by mini-css-extract-plugin
export default {"daysCover":"styles_daysCover__r1-hG","daysCover__item":"styles_daysCover__item__Fvahh"};